export default "__VITE_ASSET__XWV8BMbn__"